import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import queryString from "query-string";

export const syncYmicCOAApi = createApi({
  reducerPath: "syncYmicCOAApi",
  tagTypes: ["syncYmicCOAApi"],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_YMIR_ENDPOINT,
    prepareHeaders: (headers) => {
      headers.set("withCredentials", false);
      headers.set("Accept", "application/json");
      headers.set("API_KEY", process.env.REACT_APP_ONE_CHARGING_API_KEY);

      return headers;
    },
    paramsSerializer: (params) => {
      return queryString.stringify(params, {
        skipNull: true,
        skipEmptyString: true,
      });
    },
  }),
  endpoints: (builder) => ({
    fetchSyncYmirCompanies: builder.query({
      query: (params) => ({
        url: "https://api-one.rdfmis.com/api/companies_api?per_page=10&page=1&pagination=none&status=active",
        method: "GET",
        params,
      }),

      transformResponse: (response) => {
        //console.log({ response });
        return response.data;
      },
    }),
    fetchSyncYmirBusinessUnits: builder.query({
      query: (params) => ({
        url: "https://api-one.rdfmis.com/api/business_unit_api?per_page=10&page=1&pagination=none&status=active",
        method: "GET",
        params,
      }),

      transformResponse: (response) => response.data,
    }),
    fetchSyncYmirDepartments: builder.query({
      query: (params) => ({
        url: "https://api-one.rdfmis.com/api/departments_api?per_page=10&page=1&pagination=none&status=active",
        method: "GET",
        params,
      }),

      transformResponse: (response) => response.data,
    }),
    fetchSyncYmirUnits: builder.query({
      query: (params) => ({
        url: "https://api-one.rdfmis.com/api/department_unit_api?per_page=10&page=1&pagination=none&status=active",
        method: "GET",
        params,
      }),

      transformResponse: (response) => response.data,
    }),
    fetchSyncYmirSubUnits: builder.query({
      query: (params) => ({
        url: "https://api-one.rdfmis.com/api/sub_unit_api?per_page=10&page=1&pagination=none&status=active",
        method: "GET",
        params,
      }),

      transformResponse: (response) => response.data,
    }),
    fetchSyncYmirLocations: builder.query({
      query: (params) => ({
        url: "https://api-one.rdfmis.com/api/location_api?per_page=10&page=1&pagination=none&status=active",
        method: "GET",
        params,
      }),

      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useLazyFetchSyncYmirCompaniesQuery,
  useLazyFetchSyncYmirBusinessUnitsQuery,
  useLazyFetchSyncYmirDepartmentsQuery,
  useLazyFetchSyncYmirUnitsQuery,
  useLazyFetchSyncYmirSubUnitsQuery,
  useLazyFetchSyncYmirLocationsQuery,
} = syncYmicCOAApi;
